import Button from 'assets/components/button/Button';
import ThemeButtonCircle from 'assets/components/button/themes/Theme.Button.Circle';
import ThemeButtonFileItem from 'assets/components/button/themes/Theme.Button.FileItem';
import DataMap from 'assets/components/dataMap/DataMap';
import RenderProps from 'assets/components/helpers/RenderProps';
import Icon from 'assets/components/icon/Icon';
import Media from 'assets/components/media/Media';
import Modal from 'assets/components/page/templates/Modal';
import ThemeModalLightbox from 'assets/components/page/templates/themes/Theme.Modal.LightBox';
import { getLocales } from 'assets/locales/Locale';
import { combineStrings } from 'assets/utils/data/String';
import { isValidValue } from 'assets/utils/parsersAndValidation/Validators';
import { useEffect, useState } from 'react';

type Import = {
  media: Component.Media.Import['media'][];
  title: string;
  actions(data: Export): React.ReactNode;
};
type Export = {
  media: Component.Media.Import['media'][];
  toggle(props: { isOpen: boolean; index?: number }): void;
};
export default function Gallery(props: Import) {
  const [selectedIndex, setIndex] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const { lang } = getLocales();

  useEffect(() => {
    if (selectedIndex >= props.media.length) setIndex(0);
  }, [props.media.length]);

  function prev() {
    if (!props.media.length) setIndex(0);
    setIndex((old) => (old - 1 <= 0 ? props.media.length - old - 1 : old - 1));
  }
  function next() {
    if (!props.media.length) setIndex(0);
    setIndex((old) => (old + 1) % props.media.length);
  }
  function toggle({ isOpen, index }: { isOpen: boolean; index?: number }) {
    setIsOpen(isOpen);
    if (isValidValue(index)) setIndex(index);
  }

  const previewDocument = props.media[selectedIndex];

  return (
    <>
      {RenderProps(props, 'actions', { media: props.media, toggle })}
      {isOpen && (
        <Modal
          subcomponents={ThemeModalLightbox}
          onClose={() => setIsOpen(false)}
          header={
            <>
              <Icon class="fas-gallery" />
              &nbsp;
              {combineStrings(' | ', props.title, previewDocument?.alt)}
              <Button
                class={ThemeButtonCircle}
                style={{ buttonText: { textTransform: 'unset' }, button: { marginLeft: 'auto' } }}
                url={previewDocument?.url}
                media={<Icon class="fas-download" />}
                target="_blank"
                children={lang.download}
                disabled={!previewDocument}
                htmlElementProps={{ title: lang.download }}
              />
            </>
          }
          render={!previewDocument ? <Icon class="fas-link-broken" /> : <Media media={previewDocument} />}
          footer={
            props.media.length > 1 && (
              <>
                <Button
                  onClick={prev}
                  media="fas-chevron-left"
                  class={ThemeButtonFileItem}
                  htmlElementProps={{ title: lang.prev }}
                />
                <DataMap
                  data={props.media}
                  render={({ data, index }) => (
                    <Button
                      key={data.url}
                      media={<Media key={index} media={data} useThumbnail />}
                      onClick={toggle}
                      data={{ isOpen: true, index }}
                      class={ThemeButtonFileItem}
                      active={index === selectedIndex}
                    />
                  )}
                />
                <Button
                  onClick={next}
                  media="fas-chevron-right"
                  class={ThemeButtonFileItem}
                  htmlElementProps={{ title: lang.next }}
                />
              </>
            )
          }
        />
      )}
    </>
  );
}
